<div class="container" [ngClass]="{ 'container--edit-state': cardOnViewing }">
    <div class="content">
      <!-- ? Initial content -->
      <ng-container *ngIf="stores === null">
        <ng-container *ngTemplateOutlet="initialState"> </ng-container>
  
        <h3 class="subheading">Stores</h3>
  
        <p class="label">
          Let's put your store on the map! Add your locations, set delivery zones,
          and customize your operating hours. Whether you have one location or
          multiple branches, this is where you'll manage all your store details.
        </p>
  
        <button mat-flat-button class="add-button" (click)="addStore()">
          Add your First Store
          <mat-icon
            class="arrow-icon"
            aria-hidden="false"
            aria-label="home icon"
            iconPositionEnd
            >arrow_right_alt</mat-icon
          >
        </button>
  
        <div class="store-icon-container">
          <img
            src="/XpressApp/assets/images/partner/onboarding/store-icon.svg"
            alt="store big icon"
          />
        </div>
      </ng-container>
  
      <!-- ? Store cards content -->
      <ng-container *ngIf="stores && stores.length">
        <ng-container *ngIf="!cardOnViewing; else onEditState">
          <ng-container *ngTemplateOutlet="normalState"> </ng-container>
        </ng-container>
  
        <ng-template #onEditState>
          <ng-container *ngTemplateOutlet="editState"> </ng-container>
        </ng-template>
  
        <div class="cards" [ngClass]="{ 'cards--viewing': cardOnViewing }">
          <store-card
            *ngFor="let store of stores"
            [store]="store"
            [cardOnViewing]="cardOnViewing"
            (emitStoreData)="viewStoreCard($event)"
          ></store-card>
        </div>
      </ng-container>
    </div>
  
    <!-- ? Viewed one store panel -->
    <viewed-store-panel
      *ngIf="cardOnViewing"
      [cardOnViewing]="cardOnViewing"
      (closeCardViewing)="closeCardViewing()"
      (editStore)="editStore($event)"
    >
      <div #mapContainer class="map" mapContainer></div
    ></viewed-store-panel>
  </div>
  
  <ng-template #initialState>
    <div>
      <ng-content select="[header]"></ng-content>
    </div>
  </ng-template>
  
  <ng-template #normalState>
    <div class="normal-state">
      <ng-container *ngTemplateOutlet="heading"> </ng-container>
      <ng-container *ngTemplateOutlet="addStoreButton"> </ng-container>
      <ng-container *ngTemplateOutlet="nextButton"> </ng-container>
    </div>
  </ng-template>
  
  <ng-template #editState>
    <div class="edit-state">
      <ng-container *ngTemplateOutlet="backButton"> </ng-container>
      <ng-container *ngTemplateOutlet="addStoreButton"> </ng-container>
      <ng-container *ngTemplateOutlet="nextButton"> </ng-container>
    </div>
  
    <ng-container *ngTemplateOutlet="heading"> </ng-container>
  </ng-template>
  
  <ng-template #heading>
    <h2 *ngIf="!isActive" class="heading">Create your store</h2>
  </ng-template>
  
  <ng-template #addStoreButton>
    <button *ngIf="!isActive" mat-button class="add-button-light" (click)="addStore()">
      Add Store
    </button>
  </ng-template>
  
  <ng-template #backButton>
    <button *ngIf="!isActive" mat-button (click)="closeCardViewing()">
      Back
      <mat-icon class="arrow-icon" aria-hidden="false" aria-label="next icon"
        >arrow_back</mat-icon
      >
    </button>
  </ng-template>
  
  <ng-template #nextButton>
    <button *ngIf="!isActive" mat-flat-button class="add-button" (click)="onNext()">
      Next
      <mat-icon
        class="arrow-icon"
        aria-hidden="false"
        aria-label="next icon"
        iconPositionEnd
        >arrow_right_alt</mat-icon
      >
    </button>
  </ng-template>
  